module.exports = __webpack_public_path__ + "static/media/login-bkgd-2.24dc3719.png";